import { z } from 'zod';
import { phoneSchema } from '../phone/phone.js';
/**
 * تأكيد رقم الهاتف in Transfers (transfers.md section 10, customers.md section
 * 10.5). The employee screen asks this API, which asks Customers on the
 * employee's behalf: the employee comes from the session and the purpose is
 * always CREATE, because a transfer registers the party present by phone and
 * never changes a customer's phone.
 *
 * POST /phone-verifications — sends a code, or answers `alreadyVerified`.
 */
export const transferPhoneVerificationRequestSchema = z.object({
    phone: phoneSchema,
    language: z.enum(['ar', 'en']).default('ar'),
});
//# sourceMappingURL=phone-verification.js.map